import React from 'react'
import pdf from '../../Assets/svg/pdf-logo.svg'
import cross from "../../Assets/svg/cross.svg";
import Input from './Input';

function StaticData(props) {
  // console.log('props.link',)
  return (
    <div className="static-data">
    <div className="item-title set-title">{props.title}</div>
    {props.type === 'doc' && props.value ? 
    <div className="doc-upload doc-upload-section">
       
        <div className="doc-left">
          <div className="icon">
            <img src={pdf} alt="upload" />

            <div className="upload-text">
              <div className="upload-top-text">
                {props.value}
              </div>
              <div className="upload-btm-text">
              
                  <span>{`${props?.size || '800'}kb`}  </span>
              
              </div>
            </div>
          </div>
        </div>
        {props.isEditable &&
        <div className="plus-icon upload-top-text">
          <img  src={cross} alt="plus" /> 
          <Input
            type="file"
            accept=".pdf"
            onChange={(e) => props.onDelete(e)}
          />
          {/* <img src={props.value ? cross : plus} alt="plus" /> */}
        </div>}
        <div className="plus-icon upload-top-text" onClick={() => props?.value && props?.onChange(null)}>
         <div onClick={()=>window.open(props?.docUrl)}>view</div>
          {/* <img src={props.value ? cross : plus} alt="plus" /> */}
        </div>
      </div> 
       :
    <div className="item-value">{props.value}</div>
                }
</div>
  )
}

export default StaticData
